export function formatTmt(value: number): string {
  return `${new Intl.NumberFormat('ru-RU').format(value)} TMT`
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('ru-RU').format(value)
}

export const statusLabels: Record<string, string> = {
  free: 'Свободен',
  busy: 'В поездке',
  offline: 'Офлайн',
}

export const orderStatusLabels: Record<string, string> = {
  new: 'Новый',
  assigned: 'Назначен',
  done: 'Выполнен',
}
